import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";

import Login from "./pages/Login";
import VerifyOtp from "./pages/VerifyOtp";
import Dashboard from "./pages/Dashboard";
import UploadCsv from "./pages/UploadCsv";
import RecordsList from "./pages/RecordsList";
import RecordDetail from "./pages/RecordDetail";
import Users from "./pages/Users";
import AccessManagement from "./pages/AccessManagement";
import ThemeSettings from "./pages/ThemeSettings";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />

        <Route
          path="/"
          element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
        />
        <Route
          path="/upload"
          element={<ProtectedRoute><UploadCsv /></ProtectedRoute>}
        />
        <Route
          path="/records"
          element={<ProtectedRoute><RecordsList /></ProtectedRoute>}
        />
        <Route
          path="/records/:id"
          element={<ProtectedRoute><RecordDetail /></ProtectedRoute>}
        />
        <Route
          path="/users"
          element={<ProtectedRoute><Users /></ProtectedRoute>}
        />
        <Route
          path="/access"
          element={<ProtectedRoute><AccessManagement /></ProtectedRoute>}
        />
        <Route
          path="/theme"
          element={<ProtectedRoute><ThemeSettings /></ProtectedRoute>}
        />
      </Routes>
    </BrowserRouter>
  );
}